export type TrainingView = 'training' | 'finishing' | 'leaving' | 'failed' | 'gone';

/** Что показывать на маршруте тренировки.
 *
 *  Отдельная функция, потому что здесь легко ошибиться и дорого: очередь
 *  переходит в состояние «всё решено» СИНХРОННО, а запись сессии и подсчёт
 *  прироста освоенности — асинхронно. В этом промежутке очередь есть, а
 *  текущего задания уже нет.
 *
 *  Если счесть этот промежуток концом сессии и уйти на главный экран, итоги
 *  не покажутся никогда: сводка появится через несколько миллисекунд, но
 *  показывать её будет уже некому. Вместе с итогами пропадёт и кнопка
 *  «Повторить ошибки» — она живёт только там.
 *
 *  Про сводку функция обязана знать. Без неё «сводки ещё нет» и «сводка
 *  пришла, уходим» сливаются в одно состояние, а перехват выхода
 *  (`exitGuardActive`) действует в обоих — и перехватывает собственный
 *  переход приложения на итоги наравне с нажатием крестика. Ровно это и
 *  случилось: экран замирал на «Сохраняем тренировку…» с диалогом выхода
 *  поверх, и оба ответа в диалоге вели в тупик.
 *
 *  Домой отправляет только отсутствие очереди: прямой заход на `/training`
 *  без начатой тренировки. */
export function trainingView(
  hasQueue: boolean,
  hasTask: boolean,
  finishFailed: boolean,
  hasSummary: boolean,
): TrainingView {
  if (!hasQueue) return 'gone';
  if (hasTask) return 'training';
  if (hasSummary) return 'leaving';
  return finishFailed ? 'failed' : 'finishing';
}

/** Действует ли перехват выхода.
 *
 *  Он накрывает не только саму тренировку, но и дозапись: окно между
 *  последним ответом и приходом сводки не мгновенно — там читается весь
 *  журнал попыток, — и уход в это окно лишает ребёнка итогов навсегда,
 *  показывать их будет уже некому.
 *
 *  Но гаснуть он обязан ровно к приходу сводки — это состояние `leaving`.
 *  Оба края одинаково важны, и оба уже ломались, поэтому правило названо, а
 *  не размазано по условию в разметке. */
export function exitGuardActive(view: TrainingView): boolean {
  return view === 'training' || view === 'finishing';
}
